import React, {useState} from "react";
import './TroublesForQuiz.scss';
import { openTroublesFormForQuiz } from "../troubleslice";
//import { idTroubleCreate } from "../../../Admin/adminSlice";
import { setViewInputFormsForTroubles, closeViewInputFormsForTroubles, setViewAnswerForTroubles, 
    closeViewIAnswerForTroubles} from "../troubleslice";
import AddInputFormsForTroubles from "../InputFormsForTroubles/AddInputFormsForTroubles";
import AddAnswerForTroubles from "../InputFormsForTroubles/AddAnswerForTroubles";
//import DataAnswer from "./DataAnswer/DataAnswer";
import DataTrouble from "./DataTrouble/DataTrouble";
import DeleteInputFormsForAnswerTrouble from "../InputFormsForTroubles/DeleteInputFormsForAnswerTrouble";
import { closeDeleteInputFormsForAnswerTrouble, closeDeleteInputFormsForTrouble } from "../troubleslice";
import { answerTroubleDelete, troubleDelete} from "../../../Admin/adminSlice";
import DeleteInputFormsForTrouble from "../InputFormsForTroubles/DeleteInputFormsForTrouble";

const TroublesForQuiz = (props) => {

    const [openAnswer, setOpenAnswer] = useState(false);
    const [idTrouble, setIdTrouble] = useState();

    const { dispatch } = props;

    // SHOW INPUT VIEW FOR TROUBLES
    const showInputFormForTrouble = () => {
        dispatch(setViewInputFormsForTroubles());
    }


        //ON CLICK CLOSE
        const onClickClose = () => {
            dispatch(openTroublesFormForQuiz());
            dispatch(closeViewInputFormsForTroubles());
            dispatch(closeViewIAnswerForTroubles());
           // console.log('get answer for trouble');
        }


    //ON CLICK TROUBLE
    const handleOnGetAnswerTrouble = (e) => {
        //console.log('get answer for trouble');
        setOpenAnswer(!openAnswer);
        const id = Number(e.currentTarget.value);
        //console.log(typeof(id));
        setIdTrouble(id);
       
       
            
    }


    //ON DELETE TROUBLE

    const handleDeleteTrouble = () => {
        console.log('delete trouble');
                const item ={
                   // noteId: props.selectedIdNote,
                    id: Number(props.selectedIdTrouble),
                }
                dispatch(troubleDelete(item));
                dispatch(closeDeleteInputFormsForTrouble());


    }

    //ADD ANSWER
    const handleAddAnswer = (e) => {
        console.log('add answer');
        setIdTrouble(Number(e.currentTarget.value));
        dispatch(setViewAnswerForTroubles());
    }

    //RENDER TABLE OF TROUBLES
    const renderTableTroubles = () => {
        //let  data =  [{id:23, trouble:"how do it"},{id:47, trouble:"how do it quickly"},{id:48, trouble:"how do it quickly"},{id:49, trouble:"how do it quickly"},{id:67, trouble:"how do it quickly"},];
        

        let data = props.dataTroubles;

        // add array of troubles by id and part
        let resultArray = [];
          data.forEach(element => {

            if ((element.note_id === Number(props.troublesData.selectedNoteId)) && (element.note_part === Number(props.troublesData.selectedPart))) {
                resultArray.push(element);
            }

          })  

          console.log(resultArray );




            if (resultArray) {
                return (
                        
                    resultArray.map((item, index) => {
                     //console.log(item);
                    //COUNT ANSWERS
                            
                            let data1 = props.dataAnswerTroubles;
                            let resultArrayAnswers = [];
                                data1.forEach(element => {
                                    
                                if (element.trouble_id === item.trouble_id) {
                                    resultArrayAnswers.push(element);
                                }

                                });
                                
                                const countAnswers = resultArrayAnswers.length;
                            //console.log(countAnswers);
        
       
                        return(
                            
                                <DataTrouble 
                                key={index} 
                                dataAnswerTroubles={resultArrayAnswers}
                                idTrouble={idTrouble}
                                troubleId={item.trouble_id}
                                onGetAnswerTrouble = {handleOnGetAnswerTrouble}
                                
                                addAnswer = {handleAddAnswer}
                                openAnswer={openAnswer}
                                dataTroubles={props.dataTroubles}
                                troublesData={props.troublesData}
                                countAnswers={countAnswers}
                                item={item}
                                
                                dispatch={dispatch}
                                />
                            
  
                            

                            )
                        })
                        
                    )
                    } else return null;
    }

    // HANDLE DELETE ANSWER TROUBLE
    const handledeleteAnswerTrouble = () => {
        console.log('DELETE ANSWER TROUBLE');
                const item ={
                   // noteId: props.selectedIdNote,
                    id: Number(props.selectedIdAnswerTrouble),
                }
                dispatch(answerTroubleDelete(item));
                dispatch(closeDeleteInputFormsForAnswerTrouble());
    }


    //RETURN TROUBLES
        return (
            <div className="TroublesForQuiz">
                    <div className="return-menu">
                       <button className="exit" onClick={onClickClose}></button>
                    </div>
                <p> Вопросы к {props.troublesData.selectedNoteId}.{props.troublesData.selectedPart}</p>
                <div>
                <div className="table-style">
                    
                    {renderTableTroubles()}

                </div>
                </div>
                <div className="addTroublesButton">
                <button className="addButton" onClick ={showInputFormForTrouble}>Добавить</button>
                </div>
                {props.troublesData.viewInputFormsForTroubles && <AddInputFormsForTroubles
                  selectedNoteId={props.troublesData.selectedNoteId}  
                  selectedPart={props.troublesData.selectedPart}
                  userId={props.userId}  
                  dispatch = {dispatch}
                /> }
                {props.troublesData.viewAnswerForTroubles && <AddAnswerForTroubles
                  selectedTroubleId={idTrouble}  
                  
                  userId={props.userId}  
                  dispatch = {dispatch}
                /> }
                {props.troublesData.viewDeleteInputFormsForAnswerTrouble && <DeleteInputFormsForAnswerTrouble
                    handledeleteAnswerTrouble = {handledeleteAnswerTrouble}
                    dispatch={dispatch}
                    />}
                {props.troublesData.viewDeleteInputFormsForTrouble && <DeleteInputFormsForTrouble
                    handleDeleteTrouble = {handleDeleteTrouble}
                    dispatch={dispatch}
                    />} 
            </div>
        )
 
}
export default TroublesForQuiz;